import { TranslationMap } from '@trimble-gcs/i18n-types';

export function connectFileBrowserTranslations() {
  return {
    breadcrumbRoot: {
      text: $localize`:@@import.dialog.picker.connect.breadcrumbRoot:Explorer`,
      desc: 'Anchor text to open the root folder of the file explorer.',
    },
  } satisfies TranslationMap;
}
